import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';

@JsonObject

export class UniteCoursMarche {
  constructor (
    code?: string,
    libelle?: string
  ) {
    this.code = code as any;
    this.libelle = libelle as any;
  }

  @JsonProperty(String)
  code?: string;

  @JsonProperty(String)
  libelle?: string;
}
